import React, { useState, useEffect } from "react";
import { Nav, Navbar, NavDropdown, Container, Row } from "react-bootstrap";
import SocialLinks from "../../SocialLinks";
import Search from "./Search";
import { JoinWheelWatchers } from "../HeaderTopBar";
import { NavItemProps } from "../types";
import { getTarget } from "../../../utils";
import logoDefault from "../../../images/logo.png";
import mobileDefaultLogo from "../../../images/mobile-logo.png";
import { navigationIds } from "../../../analyticsTags";
import $ from "jquery";

export const NavItem: React.FC<NavItemProps> = ({
  title: parentTitle,
  below,
  absolute,
  type,
  isMobile,
}) => {
  const [open, setOpen] = useState(false);

  // functions that handle opening dropdowns based on mobile/desktop view
  // NOTE: resizing may cause very minor issues
  const handleMouseEnter = (e:any) => {
    if (!isMobile) {
      setOpen(true);
    }
  };

  const handleMouseLeave = () => {
    if (!isMobile) {
      setOpen(false);
    }
  };

  const handleFocus = (e:any) => {
    if (!isMobile) {
      setOpen(true);
    }
  };

  const handleBlur = (e:any,i:any,length:any) => {  
    if (!isMobile) {
      if(i==length)
      {
        setOpen(false);
      }
      else{
        setOpen(true);
      }
      
    }
  };

  const handleClick = () => {
    if (isMobile) {
      setOpen(!open);
    }
  };
  return below && below.length > 0 ? (
    <NavDropdown
      active={
        parentTitle
            .toLowerCase()
            .includes(window.location.pathname.split("/")[1])
      }
      href={absolute}
      title={parentTitle}
      show={open}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onFocus={handleFocus} 
      onClick={handleClick}
      id={navigationIds.computed.navigationDropdown(parentTitle)}
      className={`${type} dropdown-toggle`}
    >
      {below &&
        below.map(({ title, absolute, key, external },i) => {         
          return(
          <NavDropdown.Item
            active={absolute.includes(window.location.pathname)}
            id={navigationIds.computed.navigationDropdownItem(
              parentTitle,
              title
            )}
            key={key}
            href={absolute}
            target={getTarget(external)}
            onBlur={(e:any)=>handleBlur(e,i,below.length-1)} 
          >
            {title}
          </NavDropdown.Item>
        )}
        )}
    </NavDropdown>
  ) : (
    <Nav.Link
      id={navigationIds.computed.navigationDropdown(parentTitle)}
      href={absolute}
      className={`${type}`}
    >
      {parentTitle}
    </Nav.Link>
  );
};

const HeaderNavigation: React.FC<any> = ({
  social,
  navigation,
  joinHtml,
  logo,
  favicon,
  mobileLogo,
  removeBg,
  onJoin,
  onLogIn,
  onLogOut,
  isLoggedIn,
}) => {
  const [showMobile, setShowMobile] = useState(false);
  const [activeScrollClass, setActiveScrollClass] = useState("");
  let favIcon = document.getElementById("favicon");
  let apple_touch_icon = document.getElementById("appleTouchIcon");
  if (favIcon && favicon) {
    (favIcon as HTMLLinkElement).href = favicon;
  }
  if (apple_touch_icon && favicon) {
    (apple_touch_icon as HTMLLinkElement).href = favicon;
  }

  useEffect(() => {
    window.addEventListener("scroll", () => {
      let activeClass = "active";
      if (window.scrollY === 0) {
        activeClass = "";
      }
      setActiveScrollClass(activeClass);
    });
  }, [activeScrollClass]);

  return (
    <React.Fragment>
      <header
        className={`d-xl-block v1 wof-nav${
          removeBg ? " remove-bg" : ""
        } ${activeScrollClass}`}
      >
        <Container fluid>
          <Row>
            <Navbar
              expand="lg"
              bg="dark"
              className="col-6 col-lg-12 flex-column flex-sm-row"
            >
              <Navbar.Brand
                id={navigationIds.navigationHome}
                href="/"
                className="mr-0 mr-md-2 d-none d-lg-block"
              >
                <img className="logo" src={logo || logoDefault} alt="logo" />
              </Navbar.Brand>
              <Navbar.Toggle
                id={navigationIds.navigationMobileToggle}
                aria-controls="basic-navbar-nav"
                onClick={() => setShowMobile(!showMobile)}
              >
                <span className="mobile-toggle">
                  <span/>
                  <span/>
                  <span/>
                </span>
              </Navbar.Toggle>
              <Navbar.Brand
                id={navigationIds.navigationHome}
                href="/"
                className="mr-0 mr-md-2 d-lg-none"
              >
                <img
                  className="logo-mobile"
                  src={mobileLogo || mobileDefaultLogo}
                  alt="logo"
                />
              </Navbar.Brand>
              <Nav
                activeKey={window.location.pathname}
                role="navigation"
                aria-label="main-navigation"
                className={`flex-fill react-nav ${
                  showMobile ? "show " : ""
                }d-lg-flex`}
              >
                <div
                  className={`flex-fill align-items-center nav-inner navbar-nav mobile-nav`}
                >
                  {navigation.length>0?navigation.map((nav: any) => {
                    const parsedNav: NavItemProps = {
                      ...nav,
                      type:
                        nav.options.container_attributes &&
                        nav.options.container_attributes.class,
                    };
                    return (
                      <NavItem
                        {...parsedNav}
                        isMobile={true}
                        key={"nav_item_" + parsedNav.key}
                      />
                    );
                  }):null}
                  <Search />
                  <SocialLinks links={social} />
                </div>

                <div
                  className={`flex-fill align-items-center nav-inner navbar-nav desktop-nav`}
                >
                  {navigation.length>0?navigation.map((nav: any) => {
                    const parsedNav: NavItemProps = {
                      ...nav,
                      type:
                        nav.options.container_attributes &&
                        nav.options.container_attributes.class,
                    };
                    return (
                      <NavItem
                        {...parsedNav}
                        key={`nav_item_${parsedNav.key}`}
                        isMobile={false}
                      />
                    );
                  }):null}
                  <Search />
                  <SocialLinks links={social} />
                </div>

                <div
                  className={`react-nav-overlay${showMobile ? " show" : ""}`}
                  onClick={() => setShowMobile(false)}
                />
              </Nav>
            </Navbar>
            <JoinWheelWatchers
              isMobile={true}
              joinHtml={joinHtml}
              onLogIn={onLogIn}
              onJoin={onJoin}
              isLoggedIn={isLoggedIn}
              onLogOut={onLogOut}
            />
          </Row>
        </Container>
      </header>
      <header
        className={`d-xl-block v2 wof-nav${
          removeBg ? " remove-bg" : ""
        } ${activeScrollClass}`}
      >
        <Container fluid>
          <Row>
            <Navbar
              expand="lg"
              bg="dark"
              className="col-6 col-lg-12 flex-column flex-sm-row"
            >
              <Navbar.Brand
                id={navigationIds.navigationHome}
                href="/"
                className="mr-0 mr-md-2 d-none d-lg-block"
              >
                <img
                  className="logo"
                  src={mobileLogo || mobileDefaultLogo}
                  alt="logo"
                />
              </Navbar.Brand>
              <Navbar.Toggle
                id={navigationIds.navigationMobileToggle}
                aria-controls="basic-navbar-nav"
                onClick={() => setShowMobile(!showMobile)}
              >
                <span className="mobile-toggle">
                  <span/>
                  <span/>
                  <span/>
                </span>
              </Navbar.Toggle>
              <Navbar.Brand
                id={navigationIds.navigationHome}
                href="/"
                className="mr-0 mr-md-2 d-lg-none"
              >
                <img
                  className="logo-mobile"
                  src={mobileLogo || mobileDefaultLogo}
                  alt="logo"
                />
              </Navbar.Brand>
              <Nav
                activeKey={window.location.pathname}
                className={`flex-fill react-nav ${
                  showMobile ? "show " : ""
                }d-lg-flex`}
              >
                <div
                  className={`flex-fill align-items-center nav-inner navbar-nav mobile-nav`}
                >
                  {navigation.length>0?navigation.map((nav: any) => {
                    const parsedNav: NavItemProps = {
                      ...nav,
                      type:
                        nav.options.container_attributes &&
                        nav.options.container_attributes.class,
                    };
                    return (
                      <NavItem
                        {...parsedNav}
                        isMobile={true}
                        key={"nav_item_" + parsedNav.key}
                      />
                    );
                  }):null}
                  <Search />
                  <SocialLinks links={social} />
                </div>

                <div
                  className={`flex-fill align-items-center nav-inner navbar-nav desktop-nav`}
                >
                  {navigation.length>0?navigation.map((nav: any) => {
                    const parsedNav: NavItemProps = {
                      ...nav,
                      type:
                        nav.options.container_attributes &&
                        nav.options.container_attributes.class,
                    };
                    return (
                      <NavItem
                        {...parsedNav}
                        key={`nav_item_${parsedNav.key}`}
                        isMobile={false}
                      />
                    );
                  }):null}
                  <Search />
                  <SocialLinks links={social} />
                </div>

                <div
                  className={`react-nav-overlay${showMobile ? " show" : ""}`}
                  onClick={() => setShowMobile(false)}
                />
              </Nav>
            </Navbar>
            <JoinWheelWatchers
              isMobile={true}
              joinHtml={joinHtml}
              onLogIn={onLogIn}
              onJoin={onJoin}
              isLoggedIn={isLoggedIn}
              onLogOut={onLogOut}
            />
          </Row>
        </Container>
      </header>
    </React.Fragment>
  );
};

HeaderNavigation.defaultProps = {
  navigation: [],
  social: {},
};

export default HeaderNavigation;
